import { Container, Row, Col, Button } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import { useNavigate } from 'react-router-dom'
import { TextInput } from '../Misc/FormInput'
import { useState, useEffect } from 'react'
import axios from 'axios';
import { authFetch } from '../Auth/apiClient';
import { useMsal } from '@azure/msal-react';
import './PromoTable.css'
import 'bootstrap/dist/css/bootstrap.min.css'

const columns = [
    {
        name: 'Name',
        selector: row => row.name,
        sortable: true,
        width: "50%",
        cell: row => (
            <div>
                <div className="text-start">{row.promoId}</div>
                <div style={{ fontSize: '0.8rem', color: '#666', marginLeft: '10px' }}>{row.name}</div>
            </div>
        )
    },
    {
        name: 'Last Modified',
        selector: row => row.modifiedDate,
        /*cell: row => {() => {let date = new Date(Date.parse(row.modifiedDate));return date;}},*/
        sortable: true,
        width: "20%",
    },
    {
        name: 'Start Date',
        selector: row => row.startDate,
        sortable: true,
        width: "15%"
    },
    {
        name: 'End Date',
        selector: row => row.endDate,
        sortable: true,
        width: "15%"
    }
]

const PromoTable = () => {
    const { instance } = useMsal();
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');

    const [promos, setPromos] = useState([]);
    useEffect(() => {
        authFetch(instance, '/api/fetch_promos')
            .then((res) => {
                return res.json();
            })
            .then((data) => {
                setPromos(data);
            })
            .catch(function(error) {
                alert('There was an error connecting to the database, please refresh the page.');
            });
    }, []);
    const [loadingProducts, setLoadingProducts] = useState(false);

    // Function to get promo products with images
    const getPromoProducts = (promoId) => {
        setLoadingProducts(true);
        return authFetch(instance, `/api/promo_products_with_images/${promoId}`)
        .then((response) => response.json())
        .then((data) => {
            if (data.success) {
                return data.products;
            } else {
                console.error('Error fetching promo products:', data.error);
                return [];
            }
        })
        .catch((error) => {
            console.error('Error fetching promo products:', error);
            return [];
        })
        .finally(() => {
            setLoadingProducts(false);
        });
    };
    
    const handleRowClick = async (row) => {
        // Get products with images for this promo
        getPromoProducts(row.promoDatabaseId)
        .then((products) => {
            // Navigate to edit page with all necessary data
            navigate('/edit_promo', {
                state: {
                    promoDatabaseId: row.promoDatabaseId, 
                    promoId: row.promoId, 
                    name: row.name, 
                    startDate: row.startDate, 
                    endDate: row.endDate, 
                    products: products
                }
            });
        });
    };

    return (
        <Container>
            <Row className="text-start">
                <Col xs={6}>
                    <h2>In Store Promotions</h2>
                </Col>
                <Col xs={3} className="text-end align-self-center offset-3 d-grid">
                    <Button
                        style={{backgroundColor: "#a73c21", color: "#ffffff", textDecoration: "underline #a73c21", borderRadius: "0px",
                        borderColor: "#a73c21"}}
                        onClick={() => navigate('/new_promo')}
                    >Create New Promotion</Button>
                </Col>
            </Row>
            <hr />
            <Row>
                <Col xs={6} className="text-end">
                    <TextInput placeholder="Start typing to filter promos..." inputName="searchTerm" inputLabel="Filter:" inputValue={searchTerm} changeFunc={(event) => setSearchTerm(event.target.value)}/>
                </Col>
            </Row>
            {/* Loading indicator */}
            {loadingProducts && (
                <div className="text-center my-3">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading promo...</p>
                </div>
            )}
            <DataTable
                columns={columns}
                data={promos.filter(promo => 
                    promo.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
                    promo.promoId.toLowerCase().includes(searchTerm.toLowerCase())
                )}
                defaultSortFieldId={2}
                defaultSortAsc={false}
                highlightOnHover
                striped
                pagination
                /*onRowClicked={(row) => {
                    navigate('/edit_promo', {state: {promoDatabaseId: row.promoDatabaseId, promoId: row.promoId, name:`${row.name}`, startDate:row.startDate, endDate:row.endDate, products:row.products}});
                }}*/
               onRowClicked={handleRowClick}
            />


        </Container>
    )
}

export default PromoTable;